import { IonPage, IonRouterOutlet } from '@ionic/react';
import { Route } from 'react-router';
import TripsList from './TripsList';
import TripDetailsPage from './TripDetails';

const TripRouting: React.FC = () => {
  return (
    <IonPage>
      <IonRouterOutlet>
        <Route exact path='/trips/:tripId' component={TripDetailsPage}></Route>
        <Route exact path='/trips'>
          <TripsList />
        </Route>
      </IonRouterOutlet>
    </IonPage>
  );
};
export default TripRouting;
